module.exports = __webpack_public_path__ + "static/laboratoria@2x-1c8ef56fd28b6436fd783372bd122fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/laboratoria@2x.png
// module id = 870
// module chunks = 33019919093843 122353984331245